import { createApi } from "@reduxjs/toolkit/query/react";

import { DeviceType } from "../../../types";
import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL, GET_DEVICE_TYPE_ASSET } from "../../../Common/EndPoints";

type DeviceTypeMutationParams = {
  params: {
    id: string;
  };
};

type DeviceTypeMutationBody = {
  body: {
    label: string;
    type: string;
  };
};

export const deviceTypeApi = createApi({
  reducerPath: "deviceTypeAPI",
  baseQuery: axiosBaseQuery,
  tagTypes: ["device-types"],
  endpoints: (builder) => ({
    getDeviceTypes: builder.query<DeviceType[], { with_map?: boolean } | void>({
      query: (params) => ({
        url: APP_BASE_URL + GET_DEVICE_TYPE_ASSET, // URL to create a new post
        method: "GET",
        params,
      }),
      providesTags: ["device-types"],
      transformResponse: (_response: { error: any; success: any; data: DeviceType[] }): DeviceType[] => _response.data,
    }),
    postDeviceType: builder.mutation<any, DeviceTypeMutationBody>({
      query: ({ body }: DeviceTypeMutationBody) => {
        return { url: APP_BASE_URL + GET_DEVICE_TYPE_ASSET, method: "POST", data: body };
      },
      invalidatesTags: ["device-types"],
    }),
    editDeviceType: builder.mutation<any, DeviceTypeMutationParams & DeviceTypeMutationBody>({
      query: ({ params, body }: DeviceTypeMutationParams & DeviceTypeMutationBody) => {
        return { url: APP_BASE_URL + GET_DEVICE_TYPE_ASSET + `/${params.id}`, method: "PUT", data: body };
      },
      invalidatesTags: ["device-types"],
    }),
    deleteDeviceType: builder.mutation<any, DeviceTypeMutationParams>({
      query: ({ params }: DeviceTypeMutationParams) => {
        return { url: APP_BASE_URL + GET_DEVICE_TYPE_ASSET + `/${params.id}`, method: "PUT" };
      },
      invalidatesTags: ["device-types"],
    }),
  }),
});
